var initialized = false;
var pageConfig = window.pageConfig;
var validate = pageConfig.validate;
var i18n = require('i18n');
var util = require('../../app/util');
var addProjectLayer = require('./addProjectLayer.html');
$('body').append(addProjectLayer({}));

$.fn.form.settings.rules.projectNameForbidTest = function(value) {
  return !!value.indexOf('test');
};

module.exports = function(success) {
  if (initialized) {
    return;
  }
  initialized = true;
  var layer = $('.add-project-layer');
  layer.form({
    inline: true,
    on: 'blur',
    fields: {
      name: {
        identifier: 'name',
        rules: [{
          type: 'empty',
          prompt: i18n('tip.input.project.name')
        }, {
          type: 'maxLength[' + validate.maxProjectName + ']',
          prompt: i18n('tip.project.name.length', { min: validate.minProjectName, max: validate.maxProjectName })
        }, {
          type: 'minLength[' + validate.minProjectName + ']',
          prompt: i18n('tip.project.name.length', { min: validate.minProjectName, max: validate.maxProjectName })
        }, {
          type: 'projectNameForbidTest',
          prompt: i18n('startWithTest')
        }]
      },
      desc: {
        identifier: 'desc',
        rules: [{
          type: 'maxLength[' + validate.maxDescription + ']',
          prompt: i18n('tip.project.description.length', { max: validate.maxDescription })
        }]
      },
    },
    onSuccess: function(e, data) {
      data.is_public = !! data.is_public;
      util.loadData('/project/add', data, 'POST', function (res) {
        layer.find('.close').click();
        success(res.data);
      }, layer.find('.submit'));
    }
  });

  layer.modal({
    onHide: function () {
      layer.form('reset');
    }
  });
}


// WEBPACK FOOTER //
// ./src/pages/home/addProjectLayer.js